import { List, ListItem } from 'framework7-react';
import { ComponentType, ReactNode } from 'react';

import { PublicEntertainerEventRequestStatus } from '@shared/types/event';

import { useNavigate } from '@router/index';

import { getEntertainerSeoLink } from '@utilities/entertainerUtilities/getEntertainerSeoLink';
import { openExternalUrl } from '@utilities/openExternalUrl';

import IconButton from '@components/buttons/IconButton';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';
import { SeoLink } from '@components/layout/SeoLink/SeoLink';

import { TipEntertainerButton } from '@screens/event/EventScreen/EventScreen';

interface PartialEntertainer {
  _id: string;
  title: string;
  bookingHandle?: string;
  status?: PublicEntertainerEventRequestStatus;
  contact?: {
    venmo?: string;
    instagram?: string;
  };
}

interface EntertainerListProps {
  entertainers: PartialEntertainer[];
  ListItemAfterContent?: ComponentType<{ entertainer: PartialEntertainer }>;
}

export const EntertainersList = ({ entertainers, ListItemAfterContent }: EntertainerListProps) => {
  const navigate = useNavigate();

  return (
    <List className="mt-0 mb-2" style={{ marginLeft: ' -1rem', marginRight: '-1rem' }}>
      {entertainers?.map((entertainer) => (
        <ListItem key={entertainer._id}>
          <div
            slot="title"
            onClick={() => {
              if (entertainer.bookingHandle) {
                navigate(`/noauth/entertainer/${entertainer.bookingHandle}`);
              }
            }}
          >
            <SeoLink href={getEntertainerSeoLink(entertainer)}>{entertainer.title}</SeoLink>
          </div>

          <div slot="media">
            {entertainer.contact?.instagram && (
              <IconButton
                variant="flat"
                color="neutral"
                style={{
                  borderRadius: 4,
                  fontSize: 18,
                  height: 22,
                  width: 22,
                }}
                onClick={() => {
                  openExternalUrl(`https://instagram.com/${entertainer.contact?.instagram}`);
                }}
              >
                <FontAwesomeIcon faStyle="fab" name="instagram" />
              </IconButton>
            )}
          </div>
          <div slot="after">
            <div className="d-flex gap-2">
              {ListItemAfterContent ? (
                <ListItemAfterContent entertainer={entertainer} />
              ) : (
                entertainer.contact?.venmo && <TipEntertainerButton entertainer={entertainer} />
              )}
            </div>
          </div>
        </ListItem>
      ))}
    </List>
  );
};
